<div class="am-content">
  <div class="main-content">
    <div class="page-head">
      <h2 class="title">Advanced Pipe Ratings</h2>
      <ol class="breadcrumb">
        <li>
          <a [routerLink]="NAVIGATIONS.HOME.route">{{
            NAVIGATIONS.HOME.name
          }}</a>
        </li>
        <li class="active">Advanced Pipe Ratings</li>
      </ol>
    </div>
    <div>
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default">
            <div
              [ngStyle]="{ border: !isPreSimulationFormValid ? 'none' : '' }"
              class="panel-heading"
            >
              <div id="simulationSelectorPanel">
                <div id="simulationPanel">
                  <div *ngIf="simulationName == ''; else elseBlock">
                    Simulation
                  </div>
                  <ng-template #elseBlock>
                    <div>
                      <strong> Simulation: {{ simulationName }} </strong>
                    </div>
                  </ng-template>
                </div>
                <div>
                  <div>
                    <div id="unitSystemPanel" class="form-group">
                      <label id="unitSystemLabel">Unit System</label>
                      <div class="am-radio inline">
                        <input
                          id="rdMetric"
                          type="radio"
                          name="radioOption"
                          class="input-xs"
                          [value]="UnitSystem.SI"
                          [checked]="unitSystem === UnitSystem.SI"
                          (change)="onUnitSystemChange(UnitSystem.SI)"
                        />
                        <label for="rdMetric" class="input-xs">Metric</label>
                      </div>
                      <div class="am-radio inline">
                        <input
                          id="rdImperial"
                          type="radio"
                          name="radioOption"
                          class="input-xs"
                          [value]="UnitSystem.USC"
                          [checked]="unitSystem === UnitSystem.USC"
                          (change)="onUnitSystemChange(UnitSystem.USC)"
                        />
                        <label for="rdImperial" class="input-xs">Imperial</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <app-pre-simulation></app-pre-simulation>
            </div>
            <div
              [ngStyle]="{ display: !isPreSimulationFormValid ? 'none' : '' }"
              class="range-container"
            >
              <div class="col-md-12">
                Complete the following fields: Model Validity
                <span id="rangeModal" (click)="showRangeModal()"
                  ><b>Ranges</b></span
                >
              </div>
              <div class="col-md-12">
                <p>
                  Check existance on
                  <a href="https://dcp.tenaris.com/" target="_blank"
                    >Tenaris Premium Connections Performance Datasheets
                  </a>
                </p>
              </div>
            </div>
            <div
              [ngStyle]="{ display: !isPreSimulationFormValid ? 'none' : '' }"
              class="panel-body"
            >
              <form [formGroup]="fgAdvancedpipe" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-md-6">
                  <!-- PIPE Information -->
                  <div class="panel-default">
                    <div 
                      class="advancedpipe-panel widget-head"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                      "
                    >
                      <h3>Pipe</h3>
                      <div style="font-size: 25px; cursor: pointer">
                        <span
                          class="s7-search"
                          data-placement="right"
                          data-tooltip
                          title="Search Pipes"
                          (click)="loadModal()"
                        ></span>
                      </div>
                    </div>
                  </div>
                  <div class="row panel-body">
                    <!-- Modal DCP integrado y funcionando -->
                    <!-- <app-slotted-modal></app-slotted-modal> -->
                    <div class="row">
                      <div class="col-md-6">
                        <label class="input-xs">Outside Diameter (OD)</label>
                        <div class="xs-mb-15">
                          <div class="input-group">
                            <input
                              formControlName="outerDiameter"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'outerDiameterError'"
                              autocomplete="off"
                              [readonly]="isUser"
                            />
                            <span
                              class="input-group-addon input-xs label-dts thickness-0"
                              >{{ unitSystem === "USC" ? "in" : "mm" }}</span
                            >
                          </div>
                        </div>
                        <error-message
                          id="outerDiameterError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                      <div class="col-md-6">
                        <label class="input-xs">Nominal Wall Thickness</label>
                        <div class="xs-mb-15">
                          <div class="input-group">
                            <input
                              formControlName="wallThickness"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'wallThicknessError'"
                              autocomplete="off"
                              [readonly]="isUser"
                            />
                            <span
                              class="input-group-addon input-xs label-dts thickness-0"
                              >{{ unitSystem === "USC" ? "in" : "mm" }}</span
                            >
                          </div>
                        </div>
                        <error-message
                          id="wallThicknessError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label class="input-xs">Min Wall Thickness (API Tolerance)</label>
                        <div class="xs-mb-15">
                          <div class="input-group">
                            <input
                              formControlName="minWallThickness"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'minWallThicknessError'"
                              autocomplete="off"
                              [readonly]="isUser"
                            />
                            <span
                              class="input-group-addon input-xs label-dts thickness-0"
                              >%</span
                            >
                          </div>
                        </div>
                        <error-message
                          id="minWallThicknessError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                      <div class="col-md-6">
                        <label class="input-xs">Grade</label>
                        <div class="xs-mb-15">
                          <input
                            formControlName="grade"
                            class="form-control input-xs"
                            errorMessage
                            [errorContainerId]="'gradeError'"
                            autocomplete="off"
                            [readonly]="isUser"
                          />
                        </div>
                        <error-message
                          id="gradeError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <!-- MATERIAL Information -->
                  <div class="panel-default">
                    <div class="advancedpipe-panel widget-head">
                      <h3>Material</h3>
                    </div>
                  </div>
                  <div class="row panel-body">
                    <div class="row">
                      <div class="col-md-6">
                        <label class="input-xs">SMYS</label>
                        <div class="xs-mb-15">
                          <div class="input-group">
                            <input
                              formControlName="smys"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'smysError'"
                              autocomplete="off"
                            />
                            <span
                              class="input-group-addon input-xs label-dts thickness-0"
                              >{{
                                unitSystem === "USC" ? "ksi" : "MPa"
                              }}</span
                            >
                          </div>
                        </div>
                        <error-message
                          id="smysError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                      <div class="col-md-6">
                        <label class="input-xs">UTS</label>
                        <div class="xs-mb-15">
                          <div class="input-group">
                            <input
                              formControlName="uts"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'utsError'"
                              autocomplete="off"
                            />
                            <span
                              class="input-group-addon input-xs label-dts thickness-0"
                              >{{
                                unitSystem === "USC" ? "ksi" : "MPa"
                              }}</span
                            >
                          </div>
                        </div>
                        <error-message
                          id="utsError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label class="input-xs">Young Modulus E</label>
                        <div class="xs-mb-15">
                          <div class="input-group">
                            <input
                              formControlName="youngModulus"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'youngModulusError'"
                              autocomplete="off"
                            />
                            <span
                              class="input-group-addon input-xs label-dts thickness-0"
                              >{{
                                unitSystem === "USC" ? "ksi" : "MPa"
                              }}</span
                            >
                          </div>
                        </div>
                        <error-message
                          id="youngModulusError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                      <div class="col-md-6">
                        <label class="input-xs">Poisson Ratio</label>
                        <div class="xs-mb-15">
                          <input
                            formControlName="poisson"
                            class="form-control input-xs no-spin"
                            commaToDot
                            errorMessage
                            [errorContainerId]="'poissonError'"
                            autocomplete="off"
                          />
                        </div>
                        <error-message
                          id="poissonError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                    </div>
                  </div>
                </div>




              </div>
              <div class="row">
                <div class="col-md-6">
                  <!-- PROPERTIES Information -->
                  <div class="panel-default">
                    <div class="advancedpipe-panel widget-head">
                      <h3>Properties</h3>
                    </div>
                  </div>
                  <div class="row panel-body">
                    <div class="row">
                      <div class="col-md-6">
                        <label class="input-xs">Max. Flaw Size</label>
                        <div class="xs-mb-15">
                          <div class="input-group">
                            <input
                              formControlName="maxFlawSize"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'maxFlawSizeError'"
                              autocomplete="off"
                            />
                            <span
                              class="input-group-addon input-xs label-dts thickness-0"
                              >{{ unitSystem === "USC" ? "in" : "mm" }}</span
                            >
                          </div>
                        </div>
                        <error-message
                          id="maxFlawSizeError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                      <div class="col-md-6">
                        <label class="input-xs">Material Toughness Parameter</label>
                        <div class="xs-mb-15">
                          <input
                            formControlName="materialToughness"
                            class="form-control input-xs no-spin"
                            commaToDot
                            errorMessage
                            [errorContainerId]="'materialToughnessError'"
                            autocomplete="off"
                          />
                        </div>
                        <error-message
                          id="materialToughnessError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label class="input-xs">Ovality</label>
                        <div class="xs-mb-15">
                          <div class="input-group">
                            <input
                              formControlName="ovality"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'ovalityError'"
                              autocomplete="off"
                            />
                            <span
                              class="input-group-addon input-xs label-dts thickness-0"
                              >%</span
                            >
                          </div>
                        </div>
                        <error-message
                          id="ovalityError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                      <div class="col-md-6">
                        <label class="input-xs">Eccentricity</label>
                        <div class="xs-mb-15">
                          <div class="input-group">
                            <input
                              formControlName="eccentricity"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'eccentricityError'"
                              autocomplete="off"
                            />
                            <span
                              class="input-group-addon input-xs label-dts thickness-0"
                              >%</span
                            >
                          </div>
                        </div>
                        <error-message
                          id="eccentricityError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label class="input-xs">Residual Stress / SMYS</label>
                        <div class="xs-mb-15">
                          <input
                            formControlName="residualStress"
                            class="form-control input-xs no-spin"
                            commaToDot
                            errorMessage
                            [errorContainerId]="'residualStressError'"
                            autocomplete="off"
                          />
                        </div>
                        <error-message
                          id="residualStressError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                      <div class="col-md-6">
                        <label class="input-xs">Rotary Straightening</label>
                        <div class="xs-mb-15">
                          <ng-select
                            id="hotRotaryStraightening"
                            formControlName="hotRotaryStraightening"
                            [items]="hotRotaryOptions"
                            bindLabel="label"
                            bindValue="value"
                            [clearable]="false"
                            [searchable]="false"
                            placeholder="Select"
                            errorMessage
                            [errorContainerId]="'hotRotaryStraitheningError'"
                          >
                          </ng-select>
                        </div>
                        <error-message
                          id="hotRotaryStraitheningError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <!-- LOADS Information -->
                  <div class="panel-default">
                    <div class="advancedpipe-panel widget-head">
                      <h3>Loads</h3>
                    </div>
                  </div>
                  <div class="row panel-body">
                    <div class="row">
                      <div class="col-md-6">
                        <label class="input-xs">Real Axial Load</label>
                        <div class="xs-mb-15">
                          <div class="input-group">
                            <input
                              formControlName="realAxialLoad"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'realAxialLoadError'"
                              autocomplete="off"
                            />
                            <span
                              class="input-group-addon input-xs label-dts thickness-0"
                              >{{ unitSystem === "USC" ? "kips" : "kN" }}</span
                            >
                          </div>
                        </div>
                        <error-message
                          id="realAxialLoadError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                      <div class="col-md-6">
                        <label class="input-xs">Internal Pressure</label>
                        <div class="xs-mb-15">
                          <div class="input-group">
                            <input
                              formControlName="internalPressure"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'internalPressureError'"
                              autocomplete="off"
                            />
                            <span
                              class="input-group-addon input-xs label-dts thickness-0"
                              >{{
                                unitSystem === "USC" ? "ksi" : "MPa"
                              }}</span
                            >
                          </div>
                        </div>
                        <error-message
                          id="internalPressureError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label class="input-xs">External Pressure</label>
                        <div class="xs-mb-15">
                          <div class="input-group">
                            <input
                              formControlName="externalPressure"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'externalPressureError'"
                              autocomplete="off"
                            />
                            <span
                              class="input-group-addon input-xs label-dts thickness-0"
                              >{{
                                unitSystem === "USC" ? "ksi" : "MPa"
                              }}</span
                            >
                          </div>
                        </div>
                        <error-message
                          id="externalPressureError"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                    </div>                  </div>
                </div>
              </div>

              <div class="row row-styles">
                <div class="col-md-12" style="text-align: right">
                  <button
                    type="submit"
                    class="btn btn-primary"
                    [disabled]="fgAdvancedpipe.invalid"
                  >
                    Submit
                  </button>
                </div>
              </div>
              </form>
              
              <!-- SIMULATION OUTPUT Section -->
              <div id="simulation-output-section" *ngIf="convertedResults" class="row row-styles">
                <div class="col-md-12">
                  <div class="panel-default">
                    <div class="advancedpipe-panel widget-head">
                      <h3 id="simulation-output-title">Simulation Output</h3>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <!-- COLUMNA 1 -->
                    <div class="col-md-6">
                      
                      <!-- Tabla 1: Strength Results -->
                      <div class="panel-default">
                        <div class="advancedpipe-panel widget-head">
                          <h3>Strength Results</h3>
                        </div>
                      </div>
                      <table class="table table-advanced" style="border-left: none; border-right: none;">
                        <tbody>
                          <tr>
                            <td class="text-left">API Pipe Body Tension</td>
                            <td class="text-right">{{ convertedResults?.pBtensionAPI ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('weight') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">API Minimum Internal Yield Pressure</td>
                            <td class="text-right">{{ convertedResults?.burstAPI ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('pressure') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">API Collapse Strength</td>
                            <td class="text-right">{{ convertedResults?.collapseAPI ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('pressure') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">Collapse Mode</td>
                            <td class="text-right" colspan="2" [ngClass]="{'text-danger': convertedResults?.hasErrorCollapseModeAPI}">{{ convertedResults?.collapseModeAPI ?? '-' }}</td>
                          </tr>
                        </tbody>
                      </table>


                      <!-- Tabla 2: VME Burst with Wall Reduction -->
                      <div class="panel-default">
                        <div class="advancedpipe-panel widget-head">
                          <h3>VME Burst with Wall Reduction</h3>
                        </div>
                      </div>
                      <table class="table table-advanced" style="border-left: none; border-right: none;">
                        <tbody>
                          <tr>
                            <td class="text-left">Capped-End Yield</td>
                            <td class="text-right">{{ convertedResults?.burstCappedEnd ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('pressure') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">Full Plasticization (Hill Burst)</td>
                            <td class="text-right">{{ convertedResults?.burstHill ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('pressure') }}</td>
                          </tr>
                        </tbody>
                      </table>                     

                    </div>

                    <!-- COLUMNA 2 -->
                    <div class="col-md-6">
                      
                      <!-- Tabla 1: VME Stresses -->
                      <div class="panel-default">
                        <div class="advancedpipe-panel widget-head">
                          <h3>VME Stresses</h3>
                        </div>
                      </div>
                      <table class="table table-advanced table-vme-stresses" style="border-left: none; border-right: none;">
                        <colgroup>
                          <col style="width: 30% !important;">
                          <col style="width: 25% !important;">
                          <col style="width: 25% !important;">
                          <col style="width: 20% !important;">
                        </colgroup>
                        <tbody>
                          <tr>
                            <td class="text-left"></td>
                            <td class="text-right">ID</td>
                            <td class="text-right">OD</td>
                            <td class="text-center">Unit</td>
                          </tr>
                          <tr>
                            <td class="text-left">Radial Stress (σ)</td>
                            <td class="text-right">{{ convertedResults?.radialStressID ?? '-' }}</td>
                            <td class="text-right">{{ convertedResults?.radialStressOD ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('stress') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">Hoop Stress (σ)</td>
                            <td class="text-right">{{ convertedResults?.hoopStressID ?? '-' }}</td>
                            <td class="text-right">{{ convertedResults?.hoopStressOD ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('stress') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">VME Stress </td>
                            <td class="text-right">{{ convertedResults?.vmeStressID ?? '-' }}</td>
                            <td class="text-right">{{ convertedResults?.vmeStressOD ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('stress') }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <!-- Tabla 2: Limit State -->
                      <div class="panel-default">
                        <div class="advancedpipe-panel widget-head">
                          <h3>Limit State</h3>
                        </div>
                      </div>
                      <table class="table table-advanced" style="border-left: none; border-right: none;">
                        <tbody>
                          <tr>
                            <td class="text-left">Klever-Stewart Bursts (ISO TR 10400)</td>
                            <td class="text-right">{{ convertedResults?.burstKleverStuart ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('pressure') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">Klever Generalized Tamano Collapse (ISO TR 10400)</td>
                            <td class="text-right">{{ convertedResults?.collapseKGT ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('pressure') }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                </div>
                </div>
              </div>
              <div id="detailed-calculations-section" *ngIf="advancedpipeResults" class="row row-styles">
                <div class="col-md-12">
                  <div class="panel-default">
                    <div class="advancedpipe-panel widget-head" style="display: flex; justify-content: space-between; align-items: center;">
                      <h3>Detailed Calculations</h3>
                      <button 
                        type="button" 
                        class="btn btn-sm btn-outline-secondary toggle-btn"
                        (click)="toggleSecondColumn()"
                        [title]="isSecondColumnCollapsed ? 'Expand' : 'Collapse'"
                      >
                        <i class="fa" [ngClass]="isSecondColumnCollapsed ? 'fa-expand' : 'fa-compress'"></i>
                      </button>
                    </div>
                  </div>
                </div>
                
                <div class="col-md-12 collapsible-content" [ngClass]="{'collapsed': isSecondColumnCollapsed}">
                  <div class="row">
                    <!-- COLUMNA 1 -->
                    <div class="col-md-6">
                      <!-- Calculations -->
                      <div class="panel-default">
                        <div class="advancedpipe-panel widget-head">
                          <h3>Calculations</h3>
                        </div>
                      </div>
                      <table class="table table-advanced" style="border-left: none; border-right: none;">
                        <colgroup>
                          <col style="width: 60%;">
                          <col style="width: 25%;">
                          <col style="width: 15%;">
                        </colgroup>
                        <tbody>
                          <tr>
                            <td class="text-left">Pipe ID</td>
                            <td class="text-right">{{ convertedResults?.pipeID ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('pipeID') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">Cross Sectional Area</td>
                            <td class="text-right">{{ convertedResults?.crossSectionArea ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('area') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">Moment of Inertia</td>
                            <td class="text-right">{{ convertedResults?.moi ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('moment') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">Slenderness Ratio (D/t)</td>
                            <td class="text-right">{{ convertedResults?.dsuT ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('dimensionless') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">Δp = p₀ - p₁</td>
                            <td class="text-right">{{ convertedResults?.deltaP ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('pressure') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">Equivalent Collapse Strength (p₀)</td>
                            <td class="text-right">{{ convertedResults?.equivalentCollapsePressure ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('pressure') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">Axial Stress (σ₀)</td>
                            <td class="text-right">{{ convertedResults?.axialStress ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('stress') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">Adjusted Yield Strength (Ypc)</td>
                            <td class="text-right">{{ convertedResults?.adjusedYieldStrength ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('stress') }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    
                    <!-- COLUMNA 2-->
                    <div class="col-md-6">
                      <!-- API Collapse Parameters -->
                      <div class="panel-default">
                        <div class="advancedpipe-panel widget-head">
                          <h3>API Collapse Parameters</h3>
                        </div>
                      </div>
                     
                      <div class="col-md-6" style="padding-left: 0px;">

                         <table class="table table-advanced" style="border-left: none; border-right: none;">
                        <colgroup>
                          <col style="width: 60%;">
                          <col style="width: 25%;">
                          <col style="width: 15%;">
                        </colgroup>
                        <tbody>
                          <!-- Constants Section -->
                          <tr>
                            <td colspan="3" class="bg-secondary text-white" style="text-align: left !important;"><strong>Constants</strong></td>
                          </tr>
                          <tr>
                            <td class="text-left">A</td>
                            <td class="text-right">{{ convertedResults?.apIcollConstA ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('dimensionless') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">B</td>
                            <td class="text-right">{{ convertedResults?.apIcollConstB ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('dimensionless') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">C</td>
                            <td class="text-right">{{ convertedResults?.apIcollConstC ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('dimensionless') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">F</td>
                            <td class="text-right">{{ convertedResults?.apIcollConstF ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('dimensionless') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">G</td>
                            <td class="text-right">{{ convertedResults?.apIcollConstG ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('dimensionless') }}</td>
                          </tr>
                        </tbody>
                      </table>
                      </div>
                      <div class="col-md-6" style="padding-left: 0px;">
<!-- Segunda tabla para Critical D/t -->
                      <table class="table table-advanced" style="border-left: none; border-right: none;">
                        <colgroup>
                          <col style="width: 60%;">
                          <col style="width: 25%;">
                          <col style="width: 15%;">
                        </colgroup>
                        <tbody>
                          <!-- Critical D/t Section -->
                          <tr>
                            <td colspan="3" class="bg-secondary text-white" style="text-align: left !important;"><strong>Critical D/t</strong></td>
                          </tr>
                          <tr>
                            <td class="text-left">Yield Collapse ≤</td>
                            <td class="text-right">{{ convertedResults?.dsuTcritYieldColl ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('dimensionless') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">Plastic Collapse ≤</td>
                            <td class="text-right">{{ convertedResults?.dsuTcritPlasticColl ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('dimensionless') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">Transition Collapse ≤</td>
                            <td class="text-right">{{ convertedResults?.dsuTcritTransitionColl ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('dimensionless') }}</td>
                          </tr>
                          <tr>
                            <td class="text-left">Effective Tension</td>
                            <td class="text-right">{{ convertedResults?.effectiveTension ?? '-' }}</td>
                            <td class="text-center">{{ getResultUnit('force') }}</td>
                          </tr>
                        </tbody>
                      </table>

                      </div>
                      

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <ngx-spinner
      bdColor="rgba(0, 0, 0, 0.8)"
      size="medium"
      color="#fff"
      type="ball-clip-rotate"
      [fullScreen]="true"
      ><p style="color: white">Loading...</p></ngx-spinner
    >
  </div>
</div>

<!-- DCP Product Search Modal -->
<app-slotted-modal></app-slotted-modal>

<!-- Range Validation Modal -->
<app-advancedpipe-ranges-modal
  [show]="isRangeModalOpen"
  [unitSystem]="unitSystem"
  (close)="closeRangeModal()"
></app-advancedpipe-ranges-modal>
